module.exports = __webpack_public_path__ + "static/media/25k.8358ae35.webp";